module.exports = "mutation ($requestId: Int!, $status: FRIEND_STATUS!) {\n    friendResponse(requestId: $requestId, status: $status)\n}\n"